import React from "react";
import { Box, Container, HStack, VStack } from "@chakra-ui/react";
import TraitsPreviewContainer from "containers/TraitsPreviewContainer";
import TraitsBagContainer from "containers/TraitsBagContainer";
import TraitsSelectorContainer from "containers/TraitsSelectorContainer";
import useTraitSales from "hooks/useTraitSales";
import DressingRoomProvider from "providers/DressingRoomProvider";
import EtherPrice from "components/EtherPrice";
import V2SelectorContainer from "containers/V2SelectorContainer";
import V2Provider from "providers/V2Provider";
import V2Context from "contexts/V2Context";
import TraitCard from "components/TraitCard";
import TraitsControlsContainer from "containers/TraitsControlsContainer";
import Panel from "components/Panel";

const StorePage: React.FC = () => {
  const { traitSales, traitSalesByTokenId } = useTraitSales();

  return (
    <V2Provider>
      <Container pt="12" pb="16">
        <VStack spacing="3" align="flex-start">
          <V2Context.Consumer>
            {({ metadata }) => (
              <DressingRoomProvider
                originalTraits={metadata?.traits || []}
                availableTraits={traitSales.map((sale) => sale.tokenId)}
              >
                <Panel>
                  <VStack spacing="3">
                    <HStack
                      justify="space-between"
                      w="full"
                      spacing={{
                        base: "0",
                        sm: "8",
                      }}
                    >
                      <V2SelectorContainer basePath="/store" />

                      <TraitsControlsContainer />
                    </HStack>

                    <TraitsPreviewContainer />

                    <TraitsSelectorContainer
                      renderItem={(
                        tokenId,
                        isSelected,
                        isOriginal,
                        isVisible
                      ) => {
                        const traitSale = traitSalesByTokenId[tokenId];

                        return (
                          <Box p="2px">
                            <TraitCard
                              key={tokenId}
                              tokenId={tokenId}
                              supply={[traitSale.counter, traitSale.maxSupply]}
                              isSelected={isSelected}
                              isActive={isOriginal}
                              isVisible={isVisible}
                              imageSize="256"
                            >
                              <EtherPrice
                                amount={traitSale.price}
                                asPrice
                                fontSize="sm"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                                fontWeight="semibold"
                                iconColor="secondary.500"
                              />
                            </TraitCard>
                          </Box>
                        );
                      }}
                    />
                  </VStack>
                </Panel>

                <TraitsBagContainer />
              </DressingRoomProvider>
            )}
          </V2Context.Consumer>
        </VStack>
      </Container>
    </V2Provider>
  );
};

export default StorePage;
